<template>
  <div
    ref="pager"
    class="pager"
  >
    <div v-show="!hidePlaceholder">
      <div>
        <div
          v-if="loading"
          class="text-xs-center py-2"
        >
          <v-progress-circular
            indeterminate
            small
            color="primary"
          />
        </div>
        <template
          v-if="!loading && noneData"
        >
          <slot name="noneData" />
          <div
            v-if="!$slots.noneData"
            class="text-xs-center py-2 grey--text"
          >
            {{ noneText || '空空如也' }}
          </div>
        </template>

        <template v-if="!hidePage">
          <div v-if="pull">
            <!-- <Button
          v-if="noMore"
          type="primary"
          disabled
          @click="next">無更多數據</Button>
        <Button
          v-else-if="!loading"
          type="primary"
          @click="next">點擊加載更多數據</Button> -->
          </div>
          <div
            v-else
            v-show="!noneData && pageCount > 1"
            class="text-xs-center py-2"
          >
            <v-pagination
              v-model="number"
              :length="pageCount"
              :total-visible="7"
              @input="changeNumber"
            />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Pager',
  props: {
    size: {
      type: Number,
      default: 20
    },
    initNumber: {
      type: Number,
      default: 1
    },
    onFetch: {
      type: Function,
      required: true
    },
    autoFetch: {
      type: Boolean,
      default: true
    },
    // eslint-disable-next-line
    pull: Boolean, // 是否 瀑布式加载
    // eslint-disable-next-line
    hidePage: Boolean, // 是否 隱藏分頁按鈕
    noneText: String,
  },
  data () {
    return {
      number: this.initNumber,
      loading: false,
      noMore: false,
      noneData: false,
      total: 0,
      first: true // 第一次加载数据
    }
  },
  computed: {
    hidePlaceholder () {
      if (this.hidePage) {
        return !this.loading && !this.noneData
      } else {
        return false
      }
    },
    pageCount () {
      if (this.total === 0) {
        return 0
      }
      return parseInt(this.total / this.size) + (this.total % this.size > 0 ? 1 : 0)
    },
    scrollEl () {
      if (this.scroller) {
        const scrolls = [...document.querySelectorAll(this.scroller)]
        let scrollEl = this.$refs.pager.parentElement

        while (scrollEl && scrolls.indexOf(scrollEl) === -1) {
          scrollEl = scrollEl.parentElement
        }
        if (scrollEl) {
          return scrollEl
        }
      }
      return window
    },
  },
  created () {
    if (this.pull) {
      this.scrollEl.addEventListener('scroll', this.onScroll)
    }
    if (this.autoFetch) {
      this.fetch()
    }
  },
  destroyed () {
    this.scrollEl.removeEventListener('scroll', this.onScroll)
  },
  activated () {
    if (this.pull) {
      this.scrollEl.addEventListener('scroll', this.onScroll)
    }
  },
  deactivated () {
    this.scrollEl.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll () {
      if (this.pull && this.$refs.pager && this.$refs.pager.getBoundingClientRect().top - document.documentElement.clientHeight < window.innerHeight) {
        if (!this.loading) {
          // if (Date.now() - this.lastScrollEnd < 800) return // 0.8s 内不重复触发下一页
          if (this.noMore || this.noneData) return
          this.next()
          this.lastScrollEnd = Date.now()
        }
      }
    },
    next () {
      this.number += 1
      this.fetch()
    },
    changeNumber (v) {
      this.number = v
      this.fetch()
    },
    fetch () {
      if (this.noMore) return
      this.loading = true
      this.onFetch({
        first: this.first,
        size: this.size,
        number: this.number
      }).then(({ size, total }) => {
        this.loading = false
        this.first = false
        if (!this.pull) {
          this.total = total
        }
        // if (size < this.size) {
        if (size < 1) {
          this.noMore = true
          if (this.number === 1) {
            this.noneData = true
          }
        }
      }).catch((e) => {
        this.loading = false
        console.error(e)
      })
    },
    reload () {
      this.noneData = false
      this.noMore = false
      this.number = 1
      this.fetch()
    }
  }
}
</script>
